// Shared framer-motion variant constants — module-level objects so React
// doesn't allocate new references on every render.

export const FADE_UP = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
};

export const STAGGER_CONTAINER = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
};

export const SOFT_EASE = [0.22, 1, 0.36, 1];

// Common viewport setting for whileInView animations
export const VIEWPORT_ONCE = { once: true, margin: '-60px' };
export const VIEWPORT_ONCE_LATE = { once: true, margin: '-80px' };
